import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { RootState } from '../../store/GlobalStore'
import style from '../../styles/pages/account/Notifications.module.scss'
import {
    ModifyNotificationsFormData,
    NotificationsUpdateResponse
} from '../../utils/Interface'
import { setUser } from '../../store/slices/authSlice'
import { addNotification } from '../../store/slices/notificationSlice'
//import ToggleSwitch from '../../components/layout/ToggleSwitch'
import { useUpdateNotificationsMutation } from '../../services/UserAPI'
import ToggleSwitch from '../../components/layout/ToggleSwitch'
import arrowLeft from '../../shared/images/icon-arrow-left.svg'
const NotificationsPage: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth)
    const { register, handleSubmit, setValue } =
        useForm<ModifyNotificationsFormData>()
    const [updateNotifications, { isLoading }] =
        useUpdateNotificationsMutation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [notifications, setNotifications] = useState({
        newAnimation: (authState.user?.newAnimation as boolean) ?? true,
        cancelledAnimation: (authState.user?.cancelledAnimation as boolean) ?? true
    })

    useEffect(() => {
        if (authState.user) {
            setValue('id', Number(authState.user.id));
            setValue('newAnimation', notifications.newAnimation);
            setValue('cancelledAnimation', notifications.cancelledAnimation);
        } else {
            navigate('/se-connecter');
        }
    }, [authState.user, notifications, setValue]);

    useEffect(() => {
        setNotifications({
            newAnimation: (authState.user?.newAnimation as boolean),
            cancelledAnimation: (authState.user?.cancelledAnimation as boolean)
        })
    }, [authState.user])

    const onSubmit = async (formData: ModifyNotificationsFormData) => {
        console.log(formData)
        try {
            const result: { data: NotificationsUpdateResponse } =
                (await updateNotifications(formData)) as {
                    data: NotificationsUpdateResponse
                }
            console.log(result)
            if (result.data.msg === 'success') {
                dispatch(setUser(result.data.user))
                
                navigate('/mon-compte') // Rediriger l'utilisateur
            }
        } catch (error) {
            console.error('Failed to update user:', error)
        }
    }

        const handleToggle = (name: string) => {
            if (name in notifications) {
                setNotifications((prevState) => ({
                    ...prevState,
                    [name]: !prevState[name as keyof typeof notifications],
                }));
            } else {
                console.error(`Invalid key: ${name}`);
            }
        };

    return (
        <>
            <div className={style.TopContainer}>
                <Link to='/mon-compte'>
                    <button className={style.arrowButton}>
                        <img src={arrowLeft} alt='Arrow Left' />
                    </button>
                </Link>
                <h2>Notifications</h2>
                <p>
                    Activer ou désactiver la réception de notifications par
                    email
                </p>
            </div>

            <form
                onSubmit={handleSubmit(onSubmit)}
                className={style.ChangeNotificationForm}
                >
                {<input type='hidden' {...register('id')} />}
                <div className={style.notificationItem}>
                    <label>
                        Notifications lors de la création d'une nouvelle animation
                    </label>
                    <ToggleSwitch
                        isOn={notifications.newAnimation}
                        handleToggle={() => handleToggle('newAnimation')}
                        {...register('newAnimation')}
                    />
                </div>
                <div className={style.notificationItem}>
                    <label>
                        Notifications lors de l'annulation d'une animation par Activital
                    </label>
                    <ToggleSwitch
                        isOn={notifications.cancelledAnimation}
                        handleToggle={() =>handleToggle('cancelledAnimation')}
                        {...register('cancelledAnimation')}
                    />
                </div>
                <div className={style.buttonContainer}>
                    <Link to='/mon-compte'>
                        <button className={style.Cancel}>Annuler</button>
                    </Link>
                    <button
                        type='submit'
                        className={style.Update}>
                        Modifier
                    </button>
                </div>
            </form>
        </>
    )
}

export default NotificationsPage
